var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/DropdownInput/DropdownActionItem.js",
    _this = this;

import React from 'react';
import styled, { css } from 'styled-components';
import { MainText, DividerWrapper } from './DropdownInput';
import Divider from '../Divider';
import { withTheme } from '../../core/ThemeProvider';
import { noop } from '../../helpers';
import { responsiveStyles } from '../../core/utils/responsiveStyles';

var DropdownActionItem = function DropdownActionItem(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NoResultsWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(MainText, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 9
    }
  }, children)), /*#__PURE__*/React.createElement(DividerWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Divider, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 9
    }
  })));
};

var NoResultsWrapper = withTheme(styled.span.withConfig({
  displayName: "DropdownActionItem__NoResultsWrapper",
  componentId: "sc-1c4n1j-0"
})(function (_ref2) {
  var _coreTheme$dropDownIn, _coreTheme$dropDownIn2, _coreTheme$dropDownIn4, _coreTheme$dropDownIn5;

  var coreTheme = _ref2.coreTheme;
  return css(["display:flex;flex-direction:column;transition:all 0.2s ease;font-family:", ";", ";align-content:center;background-color:", ";padding:", "px ", "px;padding-bottom:0;color:", ";font-weight:", ";"], (_coreTheme$dropDownIn = (_coreTheme$dropDownIn2 = coreTheme.dropDownInput) === null || _coreTheme$dropDownIn2 === void 0 ? void 0 : _coreTheme$dropDownIn2.fontFamily) !== null && _coreTheme$dropDownIn !== void 0 ? _coreTheme$dropDownIn : coreTheme.secondaryThin, function (_ref3) {
    var _coreTheme$dropDownIn3;

    var coreTheme = _ref3.coreTheme;
    return Object.assign({}, responsiveStyles({
      fontSize: ((_coreTheme$dropDownIn3 = coreTheme.dropDownInput) === null || _coreTheme$dropDownIn3 === void 0 ? void 0 : _coreTheme$dropDownIn3.fontSize) || coreTheme.fs_xl
    }, coreTheme));
  }, coreTheme.cl_white, coreTheme.space_2, coreTheme.space_4, coreTheme.cl_ter_base, (_coreTheme$dropDownIn4 = (_coreTheme$dropDownIn5 = coreTheme.dropDownInput) === null || _coreTheme$dropDownIn5 === void 0 ? void 0 : _coreTheme$dropDownIn5.fontWeight) !== null && _coreTheme$dropDownIn4 !== void 0 ? _coreTheme$dropDownIn4 : 'inherit');
}));
DropdownActionItem.defaultProps = {
  children: noop
};
export default DropdownActionItem;